import createIcon from '../../createIcon';

/**
 * @component @name WaterDamage
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMy41TDIgMTIuNUg1VjIwLjVIMTlWMTIuNUgyMkwxMiAzLjVaTTEyIDE2LjVDMTAuOSAxNi41IDEwIDE1LjYgMTAgMTQuNUMxMCAxMy40IDEyIDEwLjUgMTIgMTAuNUMxMiAxMC41IDE0IDEzLjQgMTQgMTQuNUMxNCAxNS42IDEzLjEgMTYuNSAxMiAxNi41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const WaterDamage = createIcon('WaterDamage', [
  [
    'path',
    {
      d: 'M12 3.5L2 12.5H5V20.5H19V12.5H22L12 3.5ZM12 16.5C10.9 16.5 10 15.6 10 14.5C10 13.4 12 10.5 12 10.5C12 10.5 14 13.4 14 14.5C14 15.6 13.1 16.5 12 16.5Z',
      key: '1iz2gn',
    },
  ],
]);

export default WaterDamage;
